// src/hooks/useDynamicFavicon.js
import { useEffect } from 'react';

export default function useDynamicFavicon(iconUrl, opts = { persist: true, apple: true }) {
  useEffect(() => {
    if (!iconUrl && opts.persist) {
      const stored = localStorage.getItem('dynamicFaviconUrl');
      if (stored) applyFavicon(stored, { apple: opts.apple, bust: false });
      return;
    }

    if (iconUrl) {
      applyFavicon(iconUrl, { apple: opts.apple, bust: true });
      if (opts.persist) localStorage.setItem('dynamicFaviconUrl', iconUrl);
    }
  }, [iconUrl, opts.persist, opts.apple]);
}

function applyFavicon(url, { apple = true, bust = true } = {}) {
  const head = document.head;
  head.querySelectorAll("link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']")
    .forEach((el) => el.parentNode.removeChild(el));

  const finalHref = bust ? (url.includes('?') ? `${url}&v=${Date.now()}` : `${url}?v=${Date.now()}`) : url;

  const add = (rel, type) => {
    const l = document.createElement('link');
    l.rel = rel;
    if (type) l.type = type;
    l.href = finalHref;
    head.appendChild(l);
  };

  add('icon', 'image/x-icon');
  add('shortcut icon', 'image/x-icon');
  if (apple) add('apple-touch-icon');
}
